export default function ArrowRightIcon({
  width = 24,
  height = 25,
  color = '#FEFEFE',
  ...props
}) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      viewBox="0 0 24 25"
      fill="none"
      {...props}
    >
      <path
        fill={color}
        d="M11.969 20.03a.75.75 0 0 1 0-1.061l5.47-5.47H4.75a.75.75 0 0 1 0-1.5h12.69L11.97 6.53A.75.75 0 0 1 13.03 5.47l6.75 6.75a.749.749 0 0 1 0 1.061l-6.75 6.75a.75.75 0 0 1-1.061 0Z"
      />
    </svg>
  );
}
